import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Ruler, Layers3, BadgeCheck, Sparkles } from 'lucide-react';
import { BlurFade } from './magicui/blur-fade';

export const HomeHero = () => <>
  <section className="premium-hero" data-testid="category-rasvjeta" aria-label="MAXLIGHT rasvjeta">
    <picture>
      <source media="(min-width: 768px)" srcSet="/brand/maxlight-magnetic-interior.webp" />
      <img src="/brand/maxlight-allure-interior.webp" alt="MAXLIGHT rasvjeta u suvremenom interijeru" className="premium-hero-media" fetchPriority="high" data-testid="category-image-rasvjeta" />
    </picture>
    <div className="premium-hero-shade" aria-hidden="true" />
    <div className="premium-container premium-hero-inner">
      <BlurFade inView={false} className="premium-hero-copy" duration={0.65}>
        <p className="premium-eyebrow" data-testid="home-product-brand">MAXLIGHT HRVATSKA · Rasvjeta</p>
        <h1 data-testid="category-name-rasvjeta">MAXLIGHT.<span>Svjetlo s karakterom.</span></h1>
        <p className="premium-hero-description" data-testid="category-description-rasvjeta">Vaš pouzdan partner u odabiru rasvjete, s više od 15 godina iskustva na tržištu.</p>
        <div className="premium-hero-actions">
          <Link to="/webshop" className="magic-shimmer-button" data-testid="category-link-rasvjeta"><span className="magic-shimmer-content">Istraži rasvjetu <ArrowUpRight size={17} /></span></Link>
          <Link to="/katalozi" className="premium-text-link" data-testid="home-hero-catalogs">Katalozi <ArrowUpRight size={16} /></Link>
        </div>
      </BlurFade>
      <p className="premium-hero-credit" data-testid="home-hero-source">MAXLIGHT · Izvorni interijer iz kataloga</p>
    </div>
  </section>
  <div className="premium-trust-rail" data-testid="home-trust-rail"><div className="premium-container premium-trust-inner">
    {[[Sparkles, '15+ godina iskustva', 'experience'], [Layers3, '4 kolekcije rasvjete', 'collections'], [Ruler, 'Izvorni tehnički listovi', 'drawings'], [BadgeCheck, 'Cijene s 25 % PDV-a', 'vat']].map(([Icon, label, id]) =>
      <p className="premium-trust-item" key={id} data-testid={`home-trust-${id}`}><Icon aria-hidden="true" />{label}</p>)}
  </div></div>
</>;